'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { memo } from 'react';
import { normalizeVaultApyRewards } from '@/helpers/rewards';
import { useVaultV1Apy } from '@/hooks/useVaultV1Apy';
import type { VaultPerformanceData } from '../VaultPerformance.mapper';
import VaultPerformanceLayout from '../VaultPerformanceLayout';
import { ApyDataList } from './ApyDataList';
import { VaultFees } from './VaultFees';
export interface PerformanceDataListClientProps {
  chainId: ChainId;
  performance: VaultPerformanceData;
}
function PerformanceDataListClient(t0) {
  const $ = _c(24);
  const {
    chainId,
    performance
  } = t0;
  const t1 = performance.address;
  const t2 = performance.asset;
  const t3 = performance.state;
  let t4;
  if ($[0] !== performance.state.rewards) {
    t4 = normalizeVaultApyRewards(performance.state.rewards);
    $[0] = performance.state.rewards;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== performance.address || $[3] !== performance.asset || $[4] !== performance.state || $[5] !== t4) {
    t5 = {
      vaultV1: {
        address: t1,
        asset: t2,
        state: t3,
        rewards: t4
      }
    };
    $[2] = performance.address;
    $[3] = performance.asset;
    $[4] = performance.state;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    apy,
    netApy,
    performanceFee,
    points,
    rewards
  } = useVaultV1Apy(t5);
  let t6;
  if ($[7] !== apy || $[8] !== netApy || $[9] !== performance.asset || $[10] !== performance.monthlyAvgNetApyExcludingRewards || $[11] !== performance.quarterlyAvgNetApyExcludingRewards || $[12] !== performance.weeklyAvgNetApyExcludingRewards || $[13] !== performanceFee || $[14] !== points || $[15] !== rewards) {
    t6 = <VaultPerformanceLayout testId="vault-v1-performance"><ApyDataList apy={apy} netApy={netApy} apy7d={performance.weeklyAvgNetApyExcludingRewards} apy30d={performance.monthlyAvgNetApyExcludingRewards} apy90d={performance.quarterlyAvgNetApyExcludingRewards} rewards={rewards} points={points} asset={performance.asset} performanceFee={performanceFee} /></VaultPerformanceLayout>;
    $[7] = apy;
    $[8] = netApy;
    $[9] = performance.asset;
    $[10] = performance.monthlyAvgNetApyExcludingRewards;
    $[11] = performance.quarterlyAvgNetApyExcludingRewards;
    $[12] = performance.weeklyAvgNetApyExcludingRewards;
    $[13] = performanceFee;
    $[14] = points;
    $[15] = rewards;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = performance.state.feeRecipient ?? undefined;
  let t8;
  if ($[17] !== chainId || $[18] !== performance.state.fee || $[19] !== t7) {
    t8 = <VaultFees chainId={chainId} performanceFee={performance.state.fee} feeRecipient={t7} />;
    $[17] = chainId;
    $[18] = performance.state.fee;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export default memo(PerformanceDataListClient);